module.exports = __webpack_public_path__ + "img/delivery.8a7b4152.png";